import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

import { PagesBanner } from '../'
import './Funding.sass'


const Funding = ({ contentData, bgClassName }) => {
  return (
    <div className="page__wrapper funding-page">
      <Helmet>
        <title>{contentData.title} | Gulf TREE</title>
      </Helmet>
      <PagesBanner bgClassName={bgClassName} title={contentData.title} />
      <section className="page__content funding-content markdown-bullet-list">
        <div className="funding-content-left cms__content markdown-bullet-list" dangerouslySetInnerHTML={{__html: contentData.content}} />
        <div className="funding-content-right">
          {contentData.photos.map(photo =>
            <a href={photo.url} target="_blank" rel="noopener noreferrer" key={photo.name}>
              <img src={photo.photo} alt={photo.name} />
            </a>
          )}
        </div>
      </section>
    </div>
  )
}

Funding.propTypes = {
  contentData: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string.isRequired,
    photos: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      photo: PropTypes.string,
      url: PropTypes.string,
    })).isRequired
  }),
  bgClassName: PropTypes.string
}


export default Funding
